import Service, { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import ApiService from './api';
import AlertsService from './alerts';
import AnalyticsService from './analytics';
import { IntegrationDataOutSettings } from 'cio/models/integrations/data-out-type';

export default class VerifyService extends Service {
  @service api!: ApiService;
  @service alerts!: AlertsService;
  @service analytics!: AnalyticsService;

  verifyReportingWebhook = task(
    { drop: true },
    async ({ id, url, key = '', withContent }: { id: string; url: string; key: string; withContent: boolean }) => {
      try {
        await this.api.post('verify/reporting_webhook', {
          data: {
            endpoint: url,
            with_content: withContent,
            signing_key: key,
          },
        });

        this.alerts.success(
          'verify.reporting-webhook.success',
          'We sent a message to your webhook endpoint.',
          'Everything looks good!',
        );

        this.analytics.track('integration', 'reporting_webhook_test_sent', {
          success: true,
          endpointId: id,
        });

        return true;
      } catch (err) {
        this.analytics.track('integration', 'reporting_webhook_test_sent', {
          success: false,
          endpointId: id,
          response: err.errors[0]?.detail,
        });

        return false;
      }
    },
  );

  verifyDataOutIntegration = task(
    { drop: true },
    async ({
      type,
      ...dataOut
    }: {
      type: string;
      settings: IntegrationDataOutSettings;
      enabled: boolean;
      events: string[];
      resolution: boolean;
      withContent: boolean;
    }) => {
      try {
        let { alert } = await this.api.post(`integrations/data_out/${type}/verify`, {
          data: {
            data_out: dataOut,
          },
        });

        if (alert.type === 'warning') {
          this.alerts.warning('verify.data-out.warning', alert.content, alert.title);
        } else if (alert.type === 'success') {
          this.alerts.success('verify.data-out.success', alert.content, alert.title);
        }

        return true;
      } catch (err) {
        return false;
      }
    },
  );
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    verify: VerifyService;
  }
}
